import { Autocomplete } from '@wajeez-web/components/mui';
import { FieldValues, UseControllerProps } from 'react-hook-form';
import { DefaultInputTypeV2 } from '@wajeez-web/components/ui';

import { FormInputController } from '../FormInputController';
import { SelectFormTypeV2, SelectOptionV2 } from '../Types';

export interface FormAutocompleteV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    DefaultInputTypeV2 {
  fieldMeta: SelectFormTypeV2;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormAutocompleteV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormAutocompleteV2Props<TFormFields>) => {
  const { label, ...otherProps } = props;

  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ onChange, ...controllerProps }) => (
        <Autocomplete
          options={fieldMeta.fieldOptions?.selectOptions || []}
          label={fieldMeta.label}
          color="#1f7983"
          required={fieldMeta.required}
          onChange={(value) => {
            fieldMeta.onChange && fieldMeta.onChange(value as string | number);

            onChange(value);
          }}
          {...controllerProps}
          {...otherProps}
        />
      )}
      {...props}
    />
  );
};
